import React, { useState, useContext, useEffect } from 'react'
import { int } from 'framer-motion/types/render/dom/value-types/type-int'
import { DataSourceType } from '../Inputs/Input.types'
import useDatasource from '../useDatasource/useDatasource'

export interface ISecurityControlEntity {
    controlEntity: string
    category: string
    privilege: number
}

export interface ISecurableAction {
    actionId: string
    category?: string
}

export interface ISecurityContext {
    actions: ISecurableAction[]
    setActions: (actions: ISecurableAction[]) => any
    canPerform: (actionId: string) => boolean
    isFetchingSecurity: boolean
}

export interface SecurityContextProviderProps {
    actions?: ISecurableAction[]
    dataSource?: DataSourceType
}

export const SecurityContext = React.createContext<ISecurityContext>({
    actions: [],
    setActions: () => {},
    canPerform: () => {
        return false
    },
    isFetchingSecurity: true,
})

const SecurityContextProvider: React.FC<SecurityContextProviderProps> = ({
    actions,
    dataSource,
    children,
    // controlEntities = [],
}) => {
    const [_actions, setActions] = useState(actions || [])

    const req = useDatasource(dataSource)

    useEffect(() => {
        if (dataSource && req.data && req.data.actions) {
            setActions(req.data.actions)
        }
    }, [req.data])

    useEffect(() => {
        setActions(actions)
    }, [actions])

    const canPerform = (actionId) => {
        const action = _actions.find((a) => a.actionId === actionId)
        return !!action
    }

    const context: ISecurityContext = {
        actions: _actions,
        setActions,
        canPerform,
        isFetchingSecurity: req.isLoading,
    }

    return <SecurityContext.Provider value={context}>{children}</SecurityContext.Provider>
}

export default SecurityContextProvider
